import {AbstractCaIcsHbeStandardMapper} from "../abstract-ca-ics-hbe-standard.mapper";

export class FrCaIcsHbeCafSynthesisMapper extends AbstractCaIcsHbeStandardMapper {}